import { generateMutations } from '../builder'

export default {
  updateSelectedPane(state, lang) {
    state.paneLang = lang
  },
  ...generateMutations('getLanguages', 'languages'),
  ...generateMutations('getLocales', 'userLocales'),
}
